






























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class OpenDataComponet extends Vue {
  entries = [];
  isLoading = false;
  model = {
    identificationNumber: '',
    name: ''
  };
  search = null;
  dialog = false;
  selectedValue: any = [];
  searchType = 'identificationNumber';
  focused = false;

  @Prop({ default: null })
  value: any;

  @Prop({ default: false })
  isMulti!: boolean;

  @Prop({ default: '' })
  label!: string;

  @Prop({ default: false })
  isRequired!: boolean;

  @Prop({ default: false })
  isFocused!: boolean;

  get items() {
    return this.entries;
  }

  get isDisabled() {
    return !this.model || !this.model.name || this.model.name === '';
  }

  get isInvalid() {
    return this.isRequired && (this.value === undefined || this.value === null || this.value.length === 0) && (this.isFocused || this.focused);
  }

  mounted() {
    if (this.isMulti) {
      this.selectedValue = this.value ?? [];
    } else {
      if (this.value) {
        this.selectedValue.push(this.value);
      }
    }

    this.focused = this.isFocused;
  }

  save() {
    if (this.isMulti) {
      this.selectedValue.push(this.model);
      this.$emit('update-openData', this.selectedValue);
    } else {
      this.selectedValue = [];
      this.selectedValue.push(this.model);
      this.$emit('update-openData', this.model);
    }

    this.entries = [];
    this.model = { identificationNumber: '', name: '' };
    this.dialog = false;
    this.focused = true;
  }

  close() {
    this.entries = [];
    this.model = { identificationNumber: '', name: '' };
    this.dialog = false;
    this.focused = true;
  }

  deleteItem(item: any) {
    if (this.isMulti) {
      this.selectedValue.splice(this.selectedValue.indexOf(item), 1);
      this.$emit('update-openData', this.selectedValue);
    } else {
      this.selectedValue = [];
      this.$emit('update-openData', null);
    }

    this.focused = true;
  }

  @Watch('search')
  onPropertyChanged(value: any, oldValue: any) {
    if (value && (this.searchType === 'name' || value.length < 9)) {
      this.isLoading = true;

      const requestOptions = {
        headers: { 'X-Api-Key': 'api-key' }
      };

      const searchString = this.searchType === 'identificationNumber' ? `identificationNumber=${value}&name=` : `identificationNumber=&name=${value}`;

      fetch(`https://od.nittin.cz/api/subjects?${searchString}`, requestOptions)
        .then(res => res.json())
        .then(res => {
          this.entries = res;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  }
}
